export default "__VITE_ASSET__DEkGxgPd__"